<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.schemeName"
              placeholder="请输入方案名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.receiver"
              placeholder="请输入领用人"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col style="width:110px;padding-left:10px;">
            <el-checkbox
              v-model="masterList.tableQuery.search.isHasLeft"
              true-label="1"
              false-label="0"
              :checked="true"
              style="margin-top:3px;"
            >
              有剩余数量
            </el-checkbox>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
        @outLink="outLinkFun"
        @usedLink="usedLinkFun"
        @backLink="backLinkFun"
      />
    </div>
    <view-dialog
      :select-item="selectItem"
      :view-type="viewType"
      :dialog-visible.sync="dialogVisible"
      dialog-title="查询物料信息"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 权限验证
import checkPermission from '@/utils/permission'
// 查看
import ViewDialog from './components/viewDialog'
import { findOutdepotBillDetailListDataPageBySchemeStatisticsApi, exportOutdepotBillDetailListDataPageBySchemeStatisticsApi } from '@/api/outdepotBill'
export default {
  name: 'MaterialUsageStatistics',
  components: {
    CustomTable,
    TableOperation,
    ViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'material_usage_statistics_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['materials_receive_used_statistics_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: 'db.scheme_no', // 排序字段
            order: 'asc' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            schemeNo: '',
            schemeName: '',
            receiver: '',
            isHasLeft: 1,
            noViewSmoke: 0
          }
        }
      },
      id: null, // 选中的单据ID
      dialogVisible: false,
      selectItem: null, // 选中行
      viewType: null // 查看明细类型
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceNames', label: '省区', filterColumn: 'db.province_names' },
      { prop: 'cityNames', label: '城市', filterColumn: 'db.city_names' },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'db.scheme_no' },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'db.scheme_name' },
      { prop: 'provinceNames', label: '方案省区', filterColumn: 'db.province_names' },
      { prop: 'cityNames', label: '方案城市', filterColumn: 'db.city_names' },
      { prop: 'materialsName', label: '物料名称', filterColumn: 'db.materials_name' },
      { prop: 'receiver', label: '物料使用人', filterColumn: 'db.receiver' },
      { prop: 'amount', label: '领用数量', filterColumn: 'db.amount', width: 110, isBetween: true, isCustomLink: true, customLinkFun: 'outLink' },
      { prop: 'usedAmount', label: '使用数量', filterColumn: 'db.used_amount', width: 110, isBetween: true, isCustomLink: true, customLinkFun: 'usedLink' },
      { prop: 'backAmount', label: '退回数量', filterColumn: 'db.back_amount', width: 110, isBetween: true, isCustomLink: true, customLinkFun: 'backLink' },
      { prop: 'leftAmount', label: '剩余数量', filterColumn: 'db.left_amount', width: 110, isBetween: true }
    ]
    let noViewSmoke = 1
    if (checkPermission(['sample_smoke_view'])) {
      noViewSmoke = 0
    }
    this.masterList.tableQuery.search.noViewSmoke = noViewSmoke

    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      findOutdepotBillDetailListDataPageBySchemeStatisticsApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查询
    searchData () {
      // 重置右键筛选条件
      this.masterList.tableQuery.page = 1
      this.masterList.tableQuery.contextmenuWrap = []
      // 重置排序条件
      this.masterList.tableQuery.sort.prop = 'db.scheme_no'
      this.masterList.tableQuery.sort.order = 'asc'
      this.loadTableData()
    },
    outLinkFun (rowData) {
      this.viewType = 1
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    usedLinkFun (rowData) {
      this.viewType = 2
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    backLinkFun (rowData) {
      this.viewType = 3
      this.selectItem = rowData
      this.dialogVisible = !this.dialogVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      exportOutdepotBillDetailListDataPageBySchemeStatisticsApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
